module.exports = __webpack_public_path__ + "img/favicon.67d34b0d.png";